//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/Builder.js";
let d=[[[0,"AutoPosition",1,0],[0,"BlankType",1,0],[0,"Boundary",0,"CAM.Boundary",0],[0,"Diameter",1,0],[0,"EquidistantStock",1,0],[0,"FaceStock",1,0],[0,"FlipDirection",1,0],[0,"InnerDiameter",1,0],[0,"Length",1,0],[0,"MountingPosition",1,0],[0,"OuterDiameter",1,0],[0,"Point",1,"Point",0],[0,"RadialStock",1,0],[0,"ReferencePoint",1,"Point",0],[0,"TargetPoint",1,"Point",0]],[],[]];
SPLM.CAM.BoundaryTurnBlank = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.BoundaryTurnBlank";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.BoundaryTurnBlank.Type = Object.freeze({
    "Bar" : "Bar", "Tube" : "Tube", "Curve" : "Curve", "Workspace" : "Workspace"});

SPLM.CAM.BoundaryTurnBlank.Position = Object.freeze({
    "AtHeadstock" : "AtHeadstock", "AwayfromHeadstock" : "AwayfromHeadstock"});

export default SPLM;